<template>
    <div id="devCenterIndex">
        <div
            id="cheaderDevCenter"
            v-show="headershow"
            :class="currentIndex !== 0 ? 'cheader-devCenter' : 'cheader-devCenter getStarted'"
        >
            <div class="hpBanner-loge">
                <router-link class="hpBanner-pointer" :to="{ path: '/' }" tag="div"> </router-link>
                <embed class="hpBanner-img" :src="`${$baseUrl}dataMock/homePage/pkpmLogo.png`" />

                <!-- <h1 ></h1> -->
                <h1 class="hpBanner-ctx">{{ headerTile }}</h1>
                <!-- <router-link :to="{path: '/devcenter'}"  class="hpBanner-ctx" tag="h1">丨{{headerTile}}</router-link> -->
            </div>
            <!-- 大屏显示 -->
            <div v-if="devCenterItems.length !== 0" class="hpBanner-btnGroup hpBanner-login-lg">
                <router-link
                    v-for="(item, index) in devCenterItems"
                    :key="index"
                    :class="currentIndex === index ? 'btnActive' : ''"
                    class="hpBanner-btn"
                    :to="{ path: item.path }"
                    tag="a"
                    @click.native="btnClick(index)"
                >
                    {{ item.name }}
                </router-link>
            </div>
            <!-- 小屏显示 -->
            <div class="hpBanner-header-sm">
                <div class="navicon-bar" @click="navClick()">
                    <i class="fa fa-navicon"></i>
                </div>
                <transition name="fade">
                    <div v-if="this.naviconShow" class="hpBanner-menuGroup">
                        <div
                            class="hpBanner-menu"
                            v-for="item in devCenterItemsSM"
                            :key="item.id"
                            @click="btnSmClick(item.path)"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </transition>
            </div>
            <div class="hpBanner-login hpBanner-login-lg">
                <!-- <router-link class="loginCenter" :to="{path: linkBack.path}" tag="span">{{linkBack.name}}</router-link> -->
                <el-dropdown v-if="userName" @command="handleCommand" :title="userName" trigger="click">
                    <div class="main-user-img el-dropdown-link">
                        <i class="fa fa-user-o loginSty"></i>
                        <span class="main-user-welcome">&nbsp;&nbsp;您好，{{ userName }}&nbsp;</span>
                        <i class="fa fa-caret-down"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="backtoIndex">回到官网首页</el-dropdown-item>
                        <el-dropdown-item command="enterConsole">进入控制台</el-dropdown-item>
                        <el-dropdown-item command="loginOut">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div v-else class="login-button" @click="indexUserLogin">登录</div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import { userLogout, getUserNameFun, userLogin } from 'src/utils/loginUtils';

export default {
    name: 'devCenterIndex',
    computed: {},
    data() {
        return {
            searchInput: '',
            currentIndex: 0,
            headershow: true,
            naviconShow: false,
            headerTile: '开发者中心',
            userDisplayName: '登录',
            linkBack: {
                name: '构力云平台',
                path: '/',
            },
            devCenterItems: [
                {
                    name: '起步',
                    path: '/devcenter/getstarted',
                },
                {
                    name: '开发文档',
                    path: '/devcenter/devdocs',
                },
                {
                    name: '控制台',
                    path: '/devcenter/console',
                },
                {
                    name: '常见问题',
                    path: '/devcenter/commonQuestion',
                },
                //20210309 by wyx
                {
                    name: '更新日志',
                    path: '/devcenter/updateLogs',
                },
                // {
                //     name: '应用场景',
                //     path: '/devcenter/applicationScenarios',
                // },
            ],
            devCenterItemsSM: [
                {
                    name: '官网首页',
                    path: '/',
                },
                {
                    name: '开发文档',
                    path: '/devcenter/devdocs',
                },
                {
                    name: '控制台',
                    path: '/devcenter/console',
                },
                {
                    name: '常见问题',
                    path: '/devcenter/commonQuestion',
                },
                //20210309 by wyx
                {
                    name: '更新日志',
                    path: '/devcenter/updateLogs',
                },
                // {
                //     name: '应用场景',
                //     path: '/devcenter/applicationScenarios',
                // },
                {
                    name: '退出',
                    path: 'logout',
                },
            ],
            userName: '',
        };
    },
    methods: {
        indexUserLogin() {
            userLogin();
        },
        btnClick(index) {
            if (this.currentIndex === index) return;
            this.currentIndex = index;
        },
        btnSmClick(path) {
            if (path === 'logout') {
                // 登出
                this.userAppLogout();
            } else {
                this.$router.push(path);
            }
        },
        navClick() {
            this.naviconShow = !this.naviconShow;
        },
        userAppLogout() {
            userLogout().then((res) => {
                window.location = res;
            });
        },
        handleCommand(command) {
            switch (command) {
                case 'backtoIndex':
                    // 回官网
                    this.$router.push('/');
                    break;
                case 'enterConsole':
                    // 去控制台
                    this.$router.push('/devcenter/console');
                    break;
                case 'loginOut':
                    // 登出
                    this.userAppLogout();
                    break;
            }
        },
        switchCurrentId(path) {
            if (path.match(/getstarted/g)) {
                this.headershow = true;
                this.currentIndex = 0;
            } else if (path.match(/devdocs/g)) {
                this.headershow = true;
                this.currentIndex = 1;
            } else if (path.match(/console\/view/g)) {
                this.headershow = false;
                this.currentIndex = -1;
            } else if (path.match(/console/g)) {
                this.headershow = true;
                this.currentIndex = 2;
            } else if (path.match(/commonQuestion/g)) {
                this.headershow = true;
                this.currentIndex = 3;
            }
            //20210311 by wyx
            else if (path.match(/updateLogs/g)) {
                this.headershow = true;
                this.currentIndex = 4;
            }
            // else if (path.match(/applicationScenarios/g)) {
            //     this.headershow = true;
            //     this.currentIndex = 4;
            // }
        },
        getUserInfo() {
            getUserNameFun().then((accountRes) => {
                this.userName = accountRes.displayName;
            });
        },
    },
    mounted() {
        this.getUserInfo();
        // 对应模块的高亮
        this.switchCurrentId(this.$route.path);
    },
    watch: {
        $route(to) {
            // 对应模块的高亮
            this.switchCurrentId(to.path);
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
#devCenterIndex
  position: absolute;
  width: 100%;
  height: 100%;
  .cheader-devCenter.getStarted
    background-color $getStart-startColor
    .hpBanner-btnGroup
      .hpBanner-btn.btnActive
        background-color: rgba(255,255,255,0.17);
  .cheader-devCenter
    width 100%
    height 60px
    background-color $background-blue
    .hpBanner-loge
      z-index 99
      position:absolute
      left: 5.3%
      top: 12px
      display: flex
      align-items: center
      .hpBanner-pointer
        z-index 99
        cursor pointer
        background-color transparent
        position: absolute
        width: 120px
        height: 26px
      .hpBanner-img
        position: relative
        width: 120px
        height: 26px
      .hpBanner-ctx
        width: 160px
        height: 28px
        color $font-white
        font-size: $font-size-logo
        font-weight: bold
        line-height: 36px
        margin-left 15px
    .hpBanner-btnGroup
      position relative
      left 30%
      width 70%
      height 60px
      display flex
      .hpBanner-btn
        width: 10%
        height: 100%;
        font-size: 18px;
        dom_center()
        text-decoration: none;
        color: $font-white
        background-color: transparent;
      .hpBanner-btn.btnActive
        background-color: $background-lightblue;
    .hpBanner-login
      position absolute
      right 4.32%
      top 0
      display flex
      color $font-white
      height 60px
      line-height 60px
      margin 0 auto
      padding 0 15px
      &:hover
        background-color: rgba(255,255,255,0.17);
      .loginSty
        dom_center()
        width: 40px
        height: 40px
        padding 10px 10px
        font-size 18px
        color $font-white
        border: 1px solid $font-white
        border-radius 167px
        cursor pointer
      .user-name-warp
        line-height 40px
        text-align center
      .main-user-img
        display flex
        align-items center
        line-height 60px
        margin auto
        color $font-white
        .main-user-welcome
          max-width 120px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
      .login-button
        font-size 18px
        cursor pointer
  .navicon-bar
    position: absolute
    right 30px
    top 10px
    z-index: 100
    font-size 25px
    height 50px
    width 50px
    dom_center()
  .hpBanner-menuGroup
    z-index: 100
    position absolute
    right: 0px
    border-radius 5px
    background-color $background-lightblack
    margin-top 5px
    .hpBanner-menu
      height 50px
      width 120px
      dom_center()
      border: 1px solid transparent
      &:hover
        border: 1px solid $font-white
        transition border 1s ease
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/devCenterIndex.vue